'use strict';

const $ = require('jquery');

const clickHandlers = function ()
{
    const useAjax = require('./useAjax.js');

    const handleClick = function ( p_oParams )
    {
        return useAjax(p_oParams.url, p_oParams.method, p_oParams.data,  p_oParams.processData,  p_oParams.contentType);
    };

    // CRUD Handlers
    // -------------------------------------------------------------------------------------------------------------

    const handleEditClick = (id) => handleClick
    ({
        url: editForm,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: {
            id: id
        }
    });

    const handleSaveClick =  (data) => handleClick
    ({
        url: updateUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data
    });

    const handleDeleteClick =  (data) => handleClick
    ({
        url: deleteUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data
    });

    // -------------------------------------------------------------------------------------------------------------
    // Additional Datatable functions

    const handleBulkDelClick =  (ids) => handleClick
    ({
        url: bulkUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: {
            id: ids
        }
    });

    const handleAcceptClick =  (id) => handleClick
    ({
        url: acceptUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: {
            id: id
        }
    });

    const handleNotAcceptClick =  (id) => handleClick
    ({
        url: notacceptUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: {
            id: id
        }
    });

    const handleCreateClick =  (data) => handleClick
    ({
        url: createUrl,
        method: 'POST',
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data
    });

    const handleUploadClick =  (data) => handleClick
    ({
        url : uploadUrl,
        method: "POST",
        processData: false,
        contentType: false,
        data: data

    });

    const handleDeleteUploadClick =  (data) => handleClick
    ({
        url : deleteUploadsUrl,
        method: "POST",
        processData: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: data

    });


    return {

        create: handleCreateClick,
        edit: handleEditClick,
        upload: handleUploadClick,
        save: handleSaveClick,
        delete: handleDeleteClick,
        bulkDelete: handleBulkDelClick,
        accept: handleAcceptClick,
        notaccept: handleNotAcceptClick,
        deleteupload: handleDeleteUploadClick
    };
}

module.exports = clickHandlers;
